var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model)?_c('v-container',{staticClass:"transport-arrangements"},[_c('FormWrapper',{staticClass:"travel-arrangement-details",attrs:{"schema":_vm.schema,"options":_vm.options},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }